import { GridColDef } from "@mui/x-data-grid-premium";

const columnsHandler = () => {
  return [
    {
      field: "id",
      headerName: "",
      width: 0,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      sortable: false,
      hide: true,
    },
    {
      field: "codiceGruppo",
      headerName: "Codice Gruppo",
      width: 120,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "descrizione",
      headerName: "Descrizione",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      align: "left",
    },
  ] as GridColDef[];
};
export default columnsHandler;
